<template>
<span>
  <div class="tooltip-elem">{{texto}}
    <span class="tooltiptext-elem" :class="pos">{{tooltip}}</span>
  </div>
</span>
</template>

<script>
export default {
  props: {
    textPos: {
      type: String,
      required: false
    },
    texto: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      pos: this.textPos ? this.textPos : "text-top"
    };
  },
  methods: {
    getImgUrl(galIma) {
      if (galIma !== "") {
        return this.galsrc("./" + galIma + ".gif");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../sass/helpers/variables';
.tooltip-elem {
    position: relative;
    display: inline-block;
    cursor: pointer;
    border-color: rgb(89, 89, 89);
    .tooltiptext-elem {
        visibility: hidden;
        width: 400px;
        height: auto;
        // transition: width 2s;
        background-color: lighten(#938d8d, 30);
        font-weight: bold;
        color: $primary-red;
        text-align: center;
        border-radius: 6px;
        border-color: rgb(89, 89, 89);
        padding: 5px 0;
        position: absolute;
        z-index: 1;
        font-size: 16px;
        /* Position the tooltip */
        &.text-top {
            bottom: 100%;
            left: 50%;
            margin-left: -60px;
        }
        &.text-right {
            top: -5px;
            left: 105%;
        }
        &.text-left {
            top: -5px;
            right: 105%;
        }
        &.text-bottom {
            width: 120px;
            top: 100%;
            left: 50%;
            margin-left: -60px;
        }
    }
    &:hover , &:active , &:focus {
        .tooltiptext-elem {
            visibility: visible;
        }
    }
}

.tooltip .tooltiptext {
    top: -5px;
    left: 105%;
}
</style>



// WEBPACK FOOTER //
// Tooltip.vue?6d59c3c6